import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "A Natureza",
    text: "Totalmente imerso no verde, o Recanto dos Pinheiros oferece ar puro, silêncio e uma vista de tirar o fôlego da Pedra Grande — cartão-postal de Atibaia.",
  },
  {
    num: "02",
    title: "O Refúgio",
    text: "Propriedade particular e murada, com acesso controlado por senha e exclusivo de nossos hóspedes. Próxima a mercado, farmácia, posto e pet shop.",
  },
  {
    num: "03",
    title: "O Conforto",
    text: "Piscinas de borda infinita, ofurô com cromoterapia, áreas gourmet com churrasqueira e arquitetura moderna pensada para o descanso absoluto.",
  },
  {
    num: "04",
    title: "A Experiência",
    text: "Seja um retiro romântico a dois ou uma celebração com a família inteira, cada detalhe foi criado para transformar dias comuns em memórias inesquecíveis.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 },
  }),
};

export const Manifesto = () => {
  return (
    <section id="manifesto" className="bg-brand-cream py-24 md:py-36" data-testid="manifesto">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-xs md:text-sm uppercase tracking-[0.25em] font-bold text-brand-terracotta mb-4"
        >
          Manifesto
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-4xl md:text-6xl font-bold tracking-tighter leading-[0.95] text-brand-forest max-w-4xl mb-20"
        >
          Um lugar feito para desacelerar e respirar fundo.
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-x-16 gap-y-14">
          {chapters.map((c, i) => (
            <motion.div
              key={c.num}
              custom={i}
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="border-t border-brand-forest/20 pt-6"
            >
              <div className="flex items-baseline gap-6">
                <span className="text-brand-terracotta text-sm font-bold tracking-[0.2em]">
                  {c.num}
                </span>
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold tracking-tight text-brand-forest mb-3">
                    {c.title}
                  </h3>
                  <p className="text-brand-ink/75 text-base md:text-lg leading-relaxed">
                    {c.text}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
